import script from "./InterestType.vue?vue&type=script&setup=true&lang=js"
export * from "./InterestType.vue?vue&type=script&setup=true&lang=js"

import "./InterestType.vue?vue&type=style&index=0&id=3331f610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3331f610"]])

export default __exports__